import { Edit, FormTab, NumberInput, TextInput } from "react-admin";
import { FormSection } from "../ui/forms/FormSection";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";

const PhAppConfigGeneralForm = () => (
  <>
    <FormSection title="Qaynar xətt (hotline)">
      <TextInput
        source="HotlineClinicIds"
        label="Hotline clinic IDs"
        fullWidth
        helperText="Vergüllə: 70,72 — chat/zəng xüsusi axını"
      />
      <NumberInput
        source="WalkInCallClinicId"
        label="Walk-in call clinic ID"
        fullWidth
        helperText="Zəng üçün yazılmadan (məs. 70)"
      />
      <NumberInput
        source="ChildHelplineDoctorId"
        label="Child helpline doctor ID"
        fullWidth
        helperText="Backend fallback operator (TopDoktor)"
      />
      <NumberInput
        source="WomensHelplineClinicId"
        label="Women's helpline clinic ID"
        fullWidth
        helperText="Sadələşdirilmiş reytinq üçün (məs. -100)"
      />
    </FormSection>
    <FormSection title="Mərkəzlər və operatorlar (axtarış)">
      <TextInput
        source="CentersClinicIds"
        label="Centers clinic IDs"
        fullWidth
        helperText="PatientClinics — boş = bütün mərkəzlər; məs. 70,72"
      />
      <TextInput
        source="OperatorsClinicIds"
        label="Operators clinic IDs"
        fullWidth
        helperText="PatientDoctors — boş = bütün mütəxəssislər; məs. 70,72"
      />
    </FormSection>
    <FormSection title="Yardım xəritəsi (Overpass)">
      <TextInput
        source="SafetyMapHelplineNamePattern"
        label="Helpline name regex"
        fullWidth
        multiline
        minRows={2}
        helperText="OSM name~ filtri: 116111|qaynar|helpline|..."
      />
    </FormSection>
  </>
);

const PhAppConfigForm = () => (
  <LangTabbedForm>
    <FormTab label="Общее">
      <PhAppConfigGeneralForm />
    </FormTab>
    <FormTab label="🇦🇿 AZ">
      <FormSection title="Təcili zəng xəbərdarlığı">
        <TextInput
          source="EmergencyCallWarningTextAZ"
          label="Mətn (AZ)"
          fullWidth
          multiline
          minRows={4}
          helperText="102/103/112 zəngindən əvvəl göstərilir. 116111 üçün göstərilmir."
        />
      </FormSection>
      <FormSection title="Chat alt yazısı">
        <TextInput
          source="ChatFooterNoticeTextAZ"
          label="Chat alt yazısı (AZ)"
          fullWidth
          multiline
          minRows={2}
          helperText="Mesaj yazma sahəsinin üstündə həmişə göstərilir."
        />
      </FormSection>
    </FormTab>
    <FormTab label="🇷🇺 RU">
      <FormSection title="Предупреждение перед экстренным звонком">
        <TextInput
          source="EmergencyCallWarningTextRU"
          label="Текст (RU)"
          fullWidth
          multiline
          minRows={4}
          helperText="Показывается перед звонком на 102/103/112. Для 116111 не показывается."
        />
      </FormSection>
      <FormSection title="Подпись в чате">
        <TextInput
          source="ChatFooterNoticeTextRU"
          label="Подпись в чате (RU)"
          fullWidth
          multiline
          minRows={2}
          helperText="Всегда показывается над полем ввода сообщения."
        />
      </FormSection>
    </FormTab>
    <FormTab label="🇬🇧 EN">
      <FormSection title="Emergency call warning">
        <TextInput
          source="EmergencyCallWarningTextEN"
          label="Text (EN)"
          fullWidth
          multiline
          minRows={4}
          helperText="Shown before dialling 102/103/112. Not shown for 116111."
        />
      </FormSection>
      <FormSection title="Chat footer notice">
        <TextInput
          source="ChatFooterNoticeTextEN"
          label="Chat footer notice (EN)"
          fullWidth
          multiline
          minRows={2}
          helperText="Always shown above the message input area."
        />
      </FormSection>
    </FormTab>
    <FormTab label="🛡 Safety plan">
      <FormSection title="Təhlükəsizlik planı şablonu (JSON)">
        <TextInput
          source="SafetyPlanTemplateAZ"
          label="Template JSON (AZ)"
          fullWidth
          multiline
          minRows={12}
          helperText="Boş buraxsanız, tətbiqdə default AZ şablonu istifadə olunur."
        />
        <TextInput
          source="SafetyPlanTemplateRU"
          label="Template JSON (RU)"
          fullWidth
          multiline
          minRows={12}
          helperText="Boş buraxsanız, tətbiqdə default RU şablonu istifadə olunur."
        />
        <TextInput
          source="SafetyPlanTemplateEN"
          label="Template JSON (EN)"
          fullWidth
          multiline
          minRows={12}
          helperText="Boş buraxsanız, tətbiqdə default EN şablonu istifadə olunur."
        />
      </FormSection>
    </FormTab>
  </LangTabbedForm>
);

export const PhAppConfigEdit = () => (
  <Edit mutationMode="pessimistic" title="App parametrləri">
    <PhAppConfigForm />
  </Edit>
);
